<template>
  <div>
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/users">Users</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-full" label="Email" />
          <!--<select-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-full" label="Group">
            <option v-for="role in roles" :key="role.id">{{ role }}</option>
          </select-input>
        -->
          <div class="w-full lg:w-full pb-2 pr-7 mb-8">
            <p class="pt-1 pb-1 mb-1">User groups:</p>
            <multiselect
              id="roles"
              v-model="form.roles"
              placeholder="Search groups"
              :options="groups"
              :clear-on-select="false"
              :preserve-search="true"
              :searchable="true"
              mode="tags"
              class="mt-1"
              :close-on-select="false"
              :create-option="true"
              :error="form.errors.roles"
              :style="form.errors.roles ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.roles" class="form-error">{{ form.errors.roles }}</div>
          <!--</div> -->
          </div>
          <!-- <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" /> 
          <div class="flex flex-wrap mb-10 -mr-6 pl-8 pb-8 w-full lg:w-full pb-2 pr-8">-->
          <div class="w-full lg:w-full pb-2 pr-7 mb-8">
            <p class="pt-1 pb-1 mb-1">User specific permissions:</p>
            <multiselect
              id="permission"
              v-model="form.permissions"
              placeholder="Search Permissions"
              :options="permissions"
              :clear-on-select="false"
              :preserve-search="true"
              :searchable="true"
              mode="tags"
              class="mt-1"
              :close-on-select="false"
              :create-option="true"
              :error="form.errors.permissions"
              :style="form.errors.permissions ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.permissions" class="form-error">{{ form.errors.permissions }}</div>
          <!--</div> -->
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
// import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    roles: Array,
    permissions: Object,
    groups: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role: '',
        roles: [],
        permissions: [],
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
